export default "__VITE_ASSET__wRBxAQuo__"